import {
    GETMEETINGSTAFF,
    CREATEMEETINGSTAFF,
    UPDATEMEETINGSTAFF,
    DELETEMEETINGSTAFF,
  } from "../actions/types";
  
  const initialState = {};
  
  // eslint-disable-next-line import/no-anonymous-default-export
  export default function (state = initialState, action) {
    switch (action.type) {
      case CREATEMEETINGSTAFF:
        return {
          ...state,
          liveMeetingStaffSaveStatus: action.payload.success,
        };
      case GETMEETINGSTAFF:
        return {
          ...state,
          liveMeetingStaffList: action.payload.data,
        };
      case UPDATEMEETINGSTAFF:
        return {
          ...state,
          liveMeetingStaffUpdateStatus: action.payload.success,
        };
      case DELETEMEETINGSTAFF:
        return {
          ...state,
          liveMeetingStaffDeleteStatus: action.payload.success,
        };
  
      default:
        return state;
    }
  }
  